
cafm.reports = {

    init: function (e) {

        cafm.setCurrentModule(cafm.enums.CAFMModuleEnum.Reports);

        cafm.nav.router = new cafm.router.Router({
            pathName: window.location.pathname,
            routes: cafm.reports.nav.routes,
            processOnInit: true,
            cache: true,
            'default': 'ReportsBrowse',
            routeKey: e.route ? e.route.routeKey : null,
            routeArgs: e.route ? e.route.routeArgs : null
        });
    },
    nav: {
        routes: {
            ReportsBrowse: {
                path: 'browse',
                handler: function () {

                    cafm.views.main({
                        url: cafm.url.get('ReportsExplorer/ReportBrowser')
                    });
                }
            },
            ReportsBrowse2: {
                path: 'browse/{groupId}',
                noCache: true,
                handler: function (e) {

                    cafm.views.main({
                        url: cafm.url.get('ReportsExplorer/ReportBrowser/{0}', e.args.groupId)
                    });
                }
            },
            ReportsView: {
                path: 'report/{id}',
                handler: function (e) {

                    cafm.views.main({
                        url: cafm.url.get('ReportsExplorer/ViewReport/' + e.args.id),
                        onLoad: cafm.reports.reportLoaded
                    });
                }
            }
        }
    },
    moduleGroupSelected: function (e) {

        var id = $(e.currentTarget).data('id');

        if (id) {
            window.location.hash = 'browse/{0}'.format(id);
        }
    },
    reportMouseOver: function (e) {

        var text = $(e.currentTarget);
        var item = text.parents('.reportItem:first');
        var id = item.data('key');
        var reportPreview = $('#reportPreview');

        if (id) {

            cafm.reports.previewTimeout = setTimeout(function () {
                if (!reportPreview.length) {
                    $('<img/>', {
                        src: cafm.url.api('Report/GetReportPreviewImage/' + id),
                        id: 'reportPreview',
                        'class': 'reportPreview'
                    }).appendTo(item);
                }
                else {
                    reportPreview.attr('src', cafm.url.api('Report/GetReportPreviewImage/' + id)).appendTo(item).show();
                }
            }, 1000);
        }
    },
    reportMouseOut: function (e) {

        clearTimeout(cafm.reports.previewTimeout);
        $('#reportPreview').hide();
    },
    reportsBrowserTreeSelected: function (e) {

        switch (e.type) {

            case cafm.enums.TreeViewItemType.Category:

                if (e.item.parent().hasClass('contentBlockTree')) return;
                var toCollapse = $('> [data-expanded]', e.item.parent());
                e.tree.collapse(toCollapse);
                e.tree.expand(e.item);
                break;

            case cafm.enums.TreeViewItemType.Item:

                var reportId = e.item.data('key');

                cafm.nav.router.navigate(cafm.enums.Navigatable.ReportsView, {
                    id: reportId
                });

                break;
        }
    },
    reportsTreeSelected: function (e) {

        switch (e.type) {

            case cafm.enums.TreeViewItemType.FormCategory:

                cafm.reports.switchFormPanel(e);
                break;
                
            case cafm.enums.TreeViewItemType.Item:

                var isParam = $(e.event.target).closest('.tvParamVal,.tvParam').length > 0;

                if (isParam) {

                    e.item = e.item.closest('.tvItem[data-itemtype={0}]'.format(cafm.enums.TreeViewItemType.FormCategory));
                    cafm.reports.switchFormPanel(e);
                }

                break;
        }
    },
    reportLoaded: function (e) {

        cafm.forms.placeMainFormToolbar();

        $('#' + cafm.res.consts.ElementId_FormWidget).data('kendoTabStrip').select(0);

        cafm.reports.params.init();

        var report = cafm.views.getMainFormViewModel();

        cafm.nav.router.addRouteToHistory({
            itemKey: report.ID,
            itemTitle: report.Title,
            itemDetail: report.Description,
            itemType: cafm.enums.HistoryItemType.Report
        });
    },
    switchFormPanel: function (e) {

        e.tree.expand(e.item);
        $('#{0} .k-tabstrip-items [data-key="{1}"]'.format(cafm.res.consts.ElementId_FormWidget, e.item.data('key'))).click();
    },
    generateReportToolbar: {

        generate: function () {

            var viewModel = cafm.views.getMainFormViewModel(), actionViewModel = cafm.views.getActionWindowViewModel();            
            cafm.cache.set('ReportFormat', actionViewModel.get('Format'));
            cafm.actions.execute({
                url: cafm.url.api('Report/GenerateReportEmail'),
                elementId: cafm.res.consts.ElementId_ActionForm,
                preventValidationMessage: true,
                loaderSelector: '#{0}, .winButtons [data-key="Generate"]'.format(cafm.res.consts.ElementId_ActionForm),
                values: {
                    Criteria: cafm.reports.getReportCriteria(viewModel),
                    Message: cafm.reports.getMessageData(viewModel.get('Title'), actionViewModel.get('ReportToEmail')),
                    Format: cafm.util.getItemValue(actionViewModel.get('Format'))
                },
                statusCodeFuncs: {
                    200: function (res) {

                        $('#generateReportForm .cFieldSet').hide();
                        $('#generateReportForm').showMessage({
                            Title: cafm.res.str.MessageReportGenerating,
                            Type: cafm.enums.MessageType.Success
                        });
                    }
                }
            });
        },
        cancel: function () {

            cafm.toolbar.standardActionToolbar.cancel();
        }
    },
    getReportCriteria: function (viewModel) {

        var criteria = {
            ID: viewModel.get('ID'),
            Format: cafm.enums.ExportFormatData.Pdf,
            ParameterValues: []
        };

        for (var key in viewModel) {

            if (!isFunc(viewModel[key]) && key.indexOf(cafm.res.consts.FieldName_ReportParamPrefix) == 0) {

                var data = viewModel.get(key);
                var fieldName = key.replace(cafm.res.consts.FieldName_ReportParamPrefix, '@');
                var param = cafm.util.find(viewModel.Parameters.Items, function (p) {
                    return p.ParameterName == fieldName;
                });

                if (data) {

                    if (isFunc(data.toJSON)) {
                        data = data.toJSON();
                    }

                    if (!isArray(data)) {

                        if (data.value && data.text) {

                            // handle kendo dropdown selected items
                            data = data.value;
                        }

                        data = [data];
                    }
                    else if (data.length && isDefined(data[0].value)) {

                        data = cafm.util.selectValue(data, 'value');
                    }

                    if (data.length) {
                        criteria.ParameterValues.push({
                            ParameterID: param.get('ID'),
                            Values: data
                        });
                    }
                }
            }
        }

        return criteria;
    },
    getMessageData: function (title, toAddress) {

        return {
            Subject: title,
            Recipients: [{
                Address: toAddress,
                Type: cafm.enums.RecipientTypeData.To
            }]
        };
    },
    generateReportLoad: function (element) {
        
        var vm = cafm.views.getActionWindowViewModel(),
            cacheFormat = cafm.cache.get('ReportFormat');

        if (cacheFormat && cacheFormat != vm.Format && cafm.views.getMainFormViewModel().CrystalReportExists) {
            vm.set('Format', cacheFormat);
        }
    },
    getReportTimeZoneName: function (id) {
        var userZones = cafm.cache.get(cafm.res.consts.CacheKey_UserTimeZones);
        var selectedZone = cafm.util.find(userZones, z => {
            return z.ID == id;
        })
        return selectedZone.Name;
    },
    params: {

        init: function () {

            var mainForm = cafm.views.getMainForm();
            var treeView = nav.getKendoNavTree();

            treeView.element.on('click', '.tvParamVal', function (ev) {

                var item = $(ev.currentTarget);
                var handler = item.data('paramHandler')

                if (handler && isFunc(handler.removeParam)) {
                    handler.removeParam(ev);
                }
            });

            cafm.reports.params.date.setup({
                mainForm: mainForm,
                treeView: treeView
            });
            cafm.reports.params.lookup.setup({
                mainForm: mainForm,
                treeView: treeView
            });
            cafm.reports.params.dropdown.setup({
                mainForm: mainForm,
                treeView: treeView
            });
            cafm.reports.params.multiSelect.setup({
                mainForm: mainForm,
                treeView: treeView
            });
            cafm.reports.params.checkbox.setup({
                mainForm: mainForm,
                treeView: treeView
            });
            cafm.reports.params.textbox.setup({
                mainForm: mainForm,
                treeView: treeView
            });
            cafm.reports.params.timeZone.setup({
                mainForm: mainForm,
                treeView: treeView
            });
        },
        addParam: function (e) {

            cafm.util.callFunctionAsync({
                func: function () {

                    var paramTreeItem = $('[data-key="{0}"]'.format(e.fieldName), e.treeView.element);
                    var existingParamVal = $('.tvParamVal', paramTreeItem);
                    if (existingParamVal.length) {

                        existingParamVal.each(function (i, el) {

                            e.treeView.remove(el);
                        });
                    }

                    paramTreeItem.show();

                    if (!isArray(e.fieldDescription) && e.fieldDescription) {

                        var newItem = e.treeView.append({
                            text: e.fieldDescription,
                            imageUrl: cafm.url.get('Content/Themes/Default/icons/grey/1061-remove-16.png')
                        }, paramTreeItem);
                        newItem.addClass('tvParamVal').attr('data-itemtype', cafm.enums.TreeViewItemType.FilterValue);
                        newItem.attr('title', e.fieldDescription);
                        newItem.data('relatedControl', e.fieldControl);
                        newItem.data('text', e.fieldDescription);
                        newItem.data('paramHandler', e.handler);
                        return newItem;
                    }
                    else if (isArray(e.fieldDescription) && e.fieldDescription.length) {

                        var newItems = [];
                        e.fieldDescription.forEach(function (fd) {

                            var newItem = e.treeView.append({
                                text: fd,
                                imageUrl: cafm.url.get('Content/Themes/Default/icons/grey/1061-remove-16.png')
                            }, paramTreeItem);
                            newItem.addClass('tvParamVal').attr('data-itemtype', cafm.enums.TreeViewItemType.FilterValue);
                            newItem.attr('title', fd);
                            newItem.data('relatedControl', e.fieldControl);
                            newItem.data('text', fd);
                            newItem.data('paramHandler', e.handler);
                            newItems.push(newItem);
                        });
                        return newItems;
                    }
                    else {

                        paramTreeItem.hide();
                    }
                },
                timeout: 250
            })
        },
        removeParam: function (e, preventVmSet) {

            var item = $(e.target);
            if (!item.hasClass('tvParamVal')) {
                item = item.parents('.tvParamVal:first');
            }
            var fieldName = item.parents('.tvItem:first').data('key');
            var viewModel = cafm.views.getMainFormViewModel();

            if (isUndefined(preventVmSet) || !preventVmSet) {

                viewModel.set(fieldName, null);
            }

            var treeView = nav.getKendoNavTree();
            var relatedControl = item.data('relatedControl');
            var paramItem = item.parents('.tvParam:first');

            treeView.remove(item);

            if (!$('> .k-group', paramItem).length) {
                paramItem.hide();
            }

            return relatedControl;
        },
        date: {

            setup: function (e) {

                e.mainForm.getDatePickers().forEach(function (datePicker) {

                    datePicker.bind('change', function (ev) {

                        cafm.reports.params.date.addParam({

                            datePicker: datePicker,
                            treeView: e.treeView
                        });

                        // check for a group key
                        if (!isNullOrUndefined(datePicker.element.data('key'))) {

                            cafm.reports.params.date.onGroupedFieldChange({

                                datePicker: datePicker
                            });
                        }
                    });
                });
            },
            addParam: function (e) {

                var fieldName = e.datePicker.element.attr('name');
                var value = e.datePicker.value();
                var fieldDescription = value ? kendo.toString(value, 'd') : null;

                var paramItem = cafm.reports.params.addParam({

                    treeView: e.treeView,
                    fieldControl: e.datePicker,
                    fieldName: fieldName,
                    fieldDescription: fieldDescription,
                    handler: cafm.reports.params.date
                });

                if (!fieldDescription) {

                    e.datePicker.value('');
                }
            },
            removeParam: function (ev) {

                var datePicker = cafm.reports.params.removeParam(ev);
                datePicker.value('');

                cafm.reports.params.date.onGroupedFieldChange({

                    datePicker: datePicker
                });
            },
            onGroupedFieldChange: function (e) {

                var groupContainer = $(e.datePicker.element).parents('.fieldGroup:first');
                var groupKey = e.datePicker.element.data('key');
                var groupDateFields = $('.cfControl[data-key][data-fieldtype="{0}"]'.format(e.datePicker.element.data('fieldtype')), groupContainer);
                var currentGroupDateFields = groupDateFields.filter('[data-key="{0}"]'.format(groupKey));
                var otherGroupDateFields = groupDateFields.not('[data-key="{0}"]'.format(groupKey));
                var val = e.datePicker.value();

                if (!val) {

                    // check current group fields for value
                    currentGroupDateFields.each(function (i, el) {

                        var dp = $(el).data('kendoDatePicker');
                        if(!val) val = dp.value();
                    });
                }

                otherGroupDateFields.each(function (i, el) {

                    var dp = $(el).data('kendoDatePicker');
                    dp.enable(!val);

                    if (val) {

                        dp.value('');
                    }
                });
            }
        },
        lookup: {

            setup: function (e) {

                e.mainForm.getLookups().forEach(function (lookup) {

                    if (!lookup.data('showlist')) {
                        var singleLookupVal = $('input[data-role="lookupValue"]', lookup);
                        singleLookupVal.bind('change', function (ev) {

                            cafm.reports.params.lookup.addParam({

                                lookup: lookup,
                                treeView: e.treeView
                            });
                        });
                    }
                    else {

                        var list = $('.simpleList', lookup);
                        list.bind('change', function (ev) {

                            cafm.reports.params.lookup.addParam({

                                lookup: lookup,
                                treeView: e.treeView
                            });
                        });
                    }
                });
            },
            addParam: function (e) {

                var fieldName;
                var fieldDescription;

                if (!e.lookup.data('showlist')) {

                    var textBox = $('input[data-role="lookupText"]', e.lookup);
                    fieldName = textBox.attr('name');
                    fieldDescription = textBox.textVal();
                }
                else {

                    var list = $('.simpleList', e.lookup);
                    fieldName = list.data('name');
                    var items = JSON.safeParse(list.attr('data-items'));
                    if (items) {

                        fieldDescription = cafm.util.selectValue(items, 'text');
                    }
                }

                var paramItems = cafm.reports.params.addParam({

                    treeView: e.treeView,
                    fieldControl: e.lookup,
                    fieldName: fieldName,
                    fieldDescription: fieldDescription,
                    handler: cafm.reports.params.lookup
                });
            },
            removeParam: function (ev) {

                var item = $(ev.currentTarget);
                var itemText = item.data('text');                
                var lookup = item.data('relatedControl');
                cafm.reports.params.removeParam(ev, cafm.util.isTrue(lookup.data('multi')));

                $('.simpleListItem', lookup).each(function (i, el) {

                    var item = $(el);
                    if (item.text().trim() == itemText.trim()) {
                        $(item).click();
                    }
                });
            }
        },
        dropdown: {

            setup: function (e) {

                e.mainForm.getDropdowns().forEach(function (dropdown) {

                    // if the dropdowns already have a value then trigger the change event to ensure the default values are pushed onto the view model
                    if (dropdown.value()) {

                        dropdown.trigger('change');
                    }

                    // must be after the change triggers as we don't want the default values to appear as selected params in the param tree
                    dropdown.bind('change', function (ev) {

                        cafm.reports.params.dropdown.addParam({

                            dropdown: dropdown,
                            treeView: e.treeView
                        });
                    });
                });
            },
            addParam: function (e) {

                var fieldName = e.dropdown.element.attr('name');
                var fieldDescription = e.dropdown.text();
                var defaultVal = e.dropdown.element.data('default');

                var vm = cafm.views.getMainFormViewModel();
                if (vm.get(fieldName) && vm.get(fieldName).value) {

                    vm.set(fieldName, vm.get(fieldName).value);
                }

                if (!defaultVal || vm.get(fieldName) != defaultVal) {

                    var paramItem = cafm.reports.params.addParam({

                        treeView: e.treeView,
                        fieldControl: e.dropdown,
                        fieldName: fieldName,
                        fieldDescription: fieldDescription,
                        handler: cafm.reports.params.dropdown
                    });
                }
                else {

                    var treeParam = $('.tvParam[data-key="{0}"]'.format(fieldName));

                    $('.tvParamVal', treeParam).each(function (i, el) {

                        cafm.reports.params.removeParam({
                            target: el
                        });
                    });
                }
            },
            removeParam: function (ev) {

                var control = cafm.reports.params.removeParam(ev);
                control.value('');
            }
        },
        multiSelect: {

            setup: function (e) {

                e.mainForm.getMultiSelects().forEach(function (ms) {

                    var defaultVal = ms.element.data('default');
                    var val = ms.value();

                    // if the multi selects already have a value then trigger the change event to ensure the default values are pushed onto the view model
                    if (val) {
                        
                        ms.trigger('change');
                    }

                    if (val && val[0] == defaultVal) {

                        ms.value('');
                        ms.wrapper.setMultiSelectText('');
                    }

                    // must be after the change triggers as we don't want the default values to appear as selected params in the param tree
                    ms.bind('change', function (ev) {

                        cafm.reports.params.multiSelect.addParam({

                            multiSelect: ms,
                            treeView: e.treeView
                        });
                    });
                });
            },
            addParam: function (e) {

                var fieldName = e.multiSelect.element.attr('name');
                var defaultVal = e.multiSelect.element.data('default');
                var values = e.multiSelect.value();
                var fieldDescription = [];
                var dataItems = e.multiSelect.dataItems();
                var vm = cafm.views.getMainFormViewModel();

                if (!defaultVal || !cafm.util.exists(dataItems, function (di) { return parseInt(di.value) == defaultVal; })) {

                    values.forEach(function (item) {

                        var dataItem = cafm.util.find(dataItems, function (i) {

                            return i.value == item;
                        });

                        fieldDescription.push(dataItem.text);
                    });

                    // ensure the view model is updated for some reason multiselect isn't updating the vm here.
                    vm.set(fieldName, dataItems);

                    var paramItem = cafm.reports.params.addParam({

                        treeView: e.treeView,
                        fieldControl: e.multiSelect,
                        fieldName: fieldName,
                        fieldDescription: fieldDescription,
                        handler: cafm.reports.params.multiSelect
                    });
                }
                else {

                    var treeParam = $('.tvParam[data-key="{0}"]'.format(fieldName));

                    $('.tvParamVal', treeParam).each(function (i, el) {

                        cafm.reports.params.removeParam({
                            target: el
                        });
                    });

                    vm.set(fieldName, null);
                }
            },
            removeParam: function (ev) {

                var control = cafm.reports.params.removeParam(ev, true);
                var itemText = $(ev.currentTarget).text();

                $('.k-button', control.wrapper).each(function (i, el) {

                    var textItem = $('span:first', el);
                    if (textItem.text().trim() == itemText.trim()) {
                        $('.k-select', el).click();
                    }
                });
            }
        },
        checkbox: {

            setup: function (e) {

                e.mainForm.getCheckboxes().forEach(function (checkbox) {

                    $('.cfControl', checkbox).bind('change', function (ev) {

                        cafm.reports.params.checkbox.addParam({

                            checkbox: checkbox,
                            treeView: e.treeView
                        });
                    });
                });
            },
            addParam: function (e) {

                var fieldName = $('.cfControl', e.checkbox).attr('name');
                var fieldDescription = e.checkbox.isChecked() ? cafm.res.str.TextYes : cafm.res.str.TextNo;

                var paramItem = cafm.reports.params.addParam({

                    treeView: e.treeView,
                    fieldControl: e.checkbox,
                    fieldName: fieldName,
                    fieldDescription: fieldDescription,
                    handler: cafm.reports.params.checkbox
                });
            },
            removeParam: function (ev) {

                var control = cafm.reports.params.removeParam(ev);
                control.setChecked(false, true);
            }
        },
        textbox: {

            setup: function (e) {

                e.mainForm.getTextboxes().forEach(function (textbox) {

                    var tboxes = textbox.hasClass('cfTextInput') ? textbox : $('input', textbox).not('.k-formatted-value');
                    tboxes.bind('change', function (ev) {

                        cafm.reports.params.textbox.addParam({

                            textbox: $(ev.target),
                            treeView: e.treeView
                        });
                    });
                });
            },
            addParam: function (e) {

                var fieldName = e.textbox.attr('name');
                var fieldDescription = e.textbox.textVal();

                var paramItem = cafm.reports.params.addParam({

                    treeView: e.treeView,
                    fieldControl: e.textbox,
                    fieldName: fieldName,
                    fieldDescription: fieldDescription,
                    handler: cafm.reports.params.textbox
                });
            },
            removeParam: function (ev) {

                var control = cafm.reports.params.removeParam(ev);
                control.val('');
            }
        },
        timeZone: {
            setup: function (e) {
                let tzParamSelect = e.mainForm.find('#_param_session_time_zone');
                $(tzParamSelect).bind('change', function (e) {
                    let dtPickers = tzParamSelect.closest('.reportForm').getDatePickers();
                    if (dtPickers.length > 0) {
                        let tz = cafm.reports.getReportTimeZoneName(e.target.value);
                        dtPickers.forEach(function (dtp) {
                            
                            dtp.element.data('currentTimeZone', tz);
                            dtp.element.trigger('change');
                        });
                    }
                });
            }
        }
    },
    handlers: {
        browser: {
            back: function () {
                cafm.nav.router.navigate(cafm.enums.Navigatable.ReportsBrowse);
            }
        },
        form: function(e) {

            var key = e.key || e.button['data-key'];

            switch (key) {

                case 'OpenGenerateForm':

                    var viewModel = cafm.views.getMainFormViewModel();
                    cafm.views.openActionWindow({
                        url: cafm.url.get('~/reportsexplorer/generatereport/' + viewModel.ID),
                        winOpts: {
                            title: cafm.res.str.TextGenerateReport,
                            minHeight: 240
                        },
                        onLoad: cafm.reports.generateReportLoad,
                        closeOnOverlayClick: true
                    })
                    break;

                case 'Cancel':

                    cafm.nav.router.navigate(cafm.enums.Navigatable.ReportsBrowse);
                    break;
            }
        }
    }
}